import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import './VolunteerAnalytics.css'
import LoadingScreen from '../components/LoadingScreen'

const VolunteerAnalytics = () => {
  const history = useHistory()
  const [analytics, setAnalytics] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    fetchAnalytics()
  }, [])

  const fetchAnalytics = async () => {
    try {
      const token = localStorage.getItem('access_token')
      const response = await fetch('/api/volunteer/analytics', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        setAnalytics(data)
      } else {
        setError('Failed to load analytics')
      }
    } catch (err) {
      setError('Network error')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <LoadingScreen message="Loading Analytics" />
  }

  if (error || !analytics) {
    return (
      <div className="volunteer-analytics-container">
        <div className="error">{error || 'Failed to load analytics'}</div>
        <button onClick={() => history.push('/volunteer-dashboard')}>Back</button>
      </div>
    )
  }

  return (
    <div className="volunteer-analytics-container">
      <header className="page-header">
        <h1>Analytics</h1>
        <button onClick={() => history.push('/volunteer-dashboard')}>← Back</button>
      </header>

      <main className="analytics-main">
        <div className="analytics-section">
          <h2>Platform Statistics</h2>
          <div className="stats-grid">
            <div className="stat-card">
              <h3>{analytics.platform_statistics?.total_active_tests || 0}</h3>
              <p>Active Tests</p>
            </div>
            <div className="stat-card">
              <h3>{analytics.platform_statistics?.total_attempts || 0}</h3>
              <p>Total Attempts</p>
            </div>
            <div className="stat-card">
              <h3>{analytics.platform_statistics?.completed_attempts || 0}</h3>
              <p>Completed Attempts</p>
            </div>
            <div className="stat-card">
              <h3>{analytics.platform_statistics?.average_score || 0}%</h3>
              <p>Average Score</p>
            </div>
            <div className="stat-card">
              <h3>{analytics.platform_statistics?.completion_rate || 0}%</h3>
              <p>Completion Rate</p>
            </div>
          </div>
        </div>

        <div className="analytics-section">
          <h2>Your Statistics</h2>
          <div className="stats-grid">
            <div className="stat-card">
              <h3>{analytics.volunteer_statistics?.total_tasks || 0}</h3>
              <p>Total Tasks</p>
            </div>
            <div className="stat-card">
              <h3>{analytics.volunteer_statistics?.completed_tasks || 0}</h3>
              <p>Completed Tasks</p>
            </div>
            <div className="stat-card">
              <h3>{analytics.volunteer_statistics?.completion_rate || 0}%</h3>
              <p>Task Completion Rate</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default VolunteerAnalytics

